export const RequiredFieldMarker = ({placeholder}) => {
  return <span style={{display: 'inline'}} className={`required-field-marker ${placeholder ? 'placeholder-marker' : ''}`}> *</span>
}